import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getCurrentUserId, getMedsHistory } from 'store/storeValtio';
import { addArchiveToDb, deleteHistoryInDb } from 'store/localDb';
import Spinner from '../../spinner/Spinner';
import { getNowISO } from 'helpers/generalHelpers';

export default function MedicationArchive() {
  const currentUserId = getCurrentUserId();
  const history = getMedsHistory();
  const [submitted, setSubmitted] = useState(false);
  const [startDate, setStartDate] = useState(getNowISO());
  const [historyCount, setHistoryCount] = useState(0);
  console.log('Archive');

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms || 1000));
  }
  
  const updateDate = (newDate) => {
    console.log('UpdateDate', newDate);
    setStartDate(newDate);
    countHistory(newDate);
  }

  const countHistory = (date) => {
    let count = 0;
    history.forEach((h, ix) => {
      const medId = h.medicationId;
      const taken = h.date;
      if (taken < date) ++count;
      //console.log( 'csv', med.name, dt);
    });
    //console.log('HistoryCount', date, count);
    setHistoryCount(count);
  }

  useEffect(() => {
    var archiveDate = new Date();
    archiveDate.setDate(archiveDate.getDate() - 90);
    const id = archiveDate.toISOString();
    setStartDate(id);
    countHistory(id);
  }, []);

  const archiveValues = {
    date: getNowISO(),
    medicationId: '',
    quantity: 1,
    status: 'taken',
  };

  async function onSubmit() {
    console.log('submitting');
    setSubmitted(true);
    let count = 0;
    await Promise.all(history.map(async (h) => {
      const taken = h.date;
      if (taken < startDate) {
        console.log('addArchive', h );
        archiveValues.date = h.date;
        archiveValues.medicationId = h.medicationId;
        archiveValues.quantity = h.quantity;
        archiveValues.status = h.status;
        await addArchiveToDb(currentUserId, archiveValues);
        ++count;
        }
      }));

    console.log( 'ArchiveAdded: ', count);
    if (count === 0) await sleep(5000);

    count = 0;
    await Promise.all(history.map(async (h) => {
      const taken = h.date;
      if (taken < startDate) {
        console.log('deleteHistory', h );
        await deleteHistoryInDb(currentUserId, h.historyId);
        ++count;
        }
      }));

    console.log( 'HistoryDeleted: ', count);

    // for (const h of history) {
    //   const taken = h.date;
    //   if (taken < startDate) {
    //     console.log('addArchive', h );
    //     await addArchiveToDb(currentUserId, h);
    //     }
    //   };
    setSubmitted(false);
    console.log('submitted');
    }

  function handleClose() {

  }

  //console.log(csvData);
  if (submitted) return (<Spinner/>);

  return (
    <div className='mt-8 text-center font-bold text-2xl '>
      {/* style={{textAlign: 'center', height: '400px', color: 'black', marginTop: '50px'}}> */}
      Archive medication history
      <div className='mt-4'>
        <DatePicker selected={startDate} onChange={(e)=>updateDate(e)} />
      </div>
      <div className='m-8'>
        History items to archive: {historyCount}
      </div>
      <div className=''>
          <button onClick={onSubmit} disabled={submitted} className='p-2  small:ml-4 my-1 text-lg small:text-xl phone:text-2xl text-white bg-green-600'>
            Archive {historyCount} history items
          </button>
          <br />
          <button onClick={handleClose} className='p-2 mr-4 my-1 text-lg small:text-xl phone:text-2xl text-white bg-red-600'>Cancel</button>
      </div>

    </div>
  );
}
